import { Heading } from '@lululemon/ecom-pattern-library';
import cs from 'classnames';
import styles from './under-maintenance.module.scss';

export type Data = {
  underMaintenanceMessage: string;
};

type Props = {
  data: Data;
};

const UnderMaintenance = ({ data }: Props) => {
  const { underMaintenanceMessage } = data;

  return (
    <div className={styles.container}>
      <div className={cs('lll-grid lll-grid-padding', styles.gridContainer)}>
        <Heading
          data-testid="customer-support__under-maintenance-message_test-id"
          wrapperClassName={styles.message}
          tag="h1"
        >
          {underMaintenanceMessage}
        </Heading>
      </div>
    </div>
  );
};

export default UnderMaintenance;
